import getTableConversationRelation from './getTableConversationRelation';
import getTableItemRelation from './getTableItemRelation';
export default function updateInstrumentationContext(rowKey, tableView, instrumentationContext) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            var tableConversationRelation = getTableConversationRelation(rowKey, tableView.id);
            tableConversationRelation.instrumentationContext = instrumentationContext;
            break;
        case 1 /* Message */:
            var tableItemRelation = getTableItemRelation(rowKey, tableView.id);
            tableItemRelation.instrumentationContext = instrumentationContext;
            break;
    }
}
//# sourceMappingURL=updateInstrumentationContext.js.map